export enum FeeHeatmapMode {
  Projection = "Projection",
  Detail = "Detail",
}
